import {
  blobToFile,
  createDefaultImageReader,
  createDefaultImageWriter,
  locale_en_gb,
  plugin_annotate_locale_en_gb,
  plugin_crop_locale_en_gb,
  plugin_finetune_locale_en_gb,
} from "doka";
import heic2any from "heic2any";
import { heicRegex } from "./regex";

export const editorConfig = {
  imageReader: createDefaultImageReader({
    preprocessImageFile: async (file, options, onprogress) => {
      // If is not of type HEIC we skip the file
      if (!heicRegex.test(file.type)) return file;

      // Let's turn the HEIC image into JPEG so the browser can read it
      const blob = await heic2any({
        blob: file,
        toType: "image/jpeg",
        quality: 0.94,
      });

      // The editor expects a File so let's convert our Blob
      return blobToFile(blob, file.name);
    },
  }),
  imageWriter: createDefaultImageWriter({
    targetSize: {
      width: 500,
      height: 500,
      upscale: true,
    },
  }),
  imageCropAspectRatio: 3 / 2,
  locale: {
    ...locale_en_gb,
    ...plugin_crop_locale_en_gb,
    ...plugin_finetune_locale_en_gb,
    ...plugin_annotate_locale_en_gb,
  },
};
